module.exports = __webpack_public_path__ + "static/media/royal_ring.d48287b4.png";